import type { ButtonStyles } from "./button-types";
import { cn } from "../../utilities/tailwind";

export const FOCUS_OUTLINE_STYLES = cn(
  "focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-royal-blue",
);
export const FOCUS_OUTLINE_STYLES_BUTTON_LINK = cn(
  "focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-royal-blue",
);
export const FOCUS_OUTLINE_STYLES_SECONDARY = cn(
  "focus-visible:outline-dark-orange",
);
export const FOCUS_OUTLINE_STYLES_SECONDARY_LINK = cn(
  "focus-visible:outline-dark-orange",
);

const DISABLED_BUTTON_STYLES = cn(
  "disabled:pointer-events-none disabled:border disabled:border-medium-gray disabled:bg-off-white disabled:text-medium-gray",
);
const DISABLED_BUTTON_STYLES_MINIMAL = cn(
  "disabled:pointer-events-none disabled:bg-off-white disabled:text-medium-gray",
);

export const BUTTON_STYLES = {
  base: cn(
    `relative inline-block cursor-pointer rounded-xl px-6 text-center font-bold antialiased transition-colors duration-300 ${FOCUS_OUTLINE_STYLES}`,
  ),
  color: {
    darkMinimal: cn(
      "min-w-0 bg-core-blue px-2 text-white hover:text-light-gray focus-visible:text-light-gray",
    ),
    minimal: cn(
      "min-w-0 bg-white px-2 text-royal-blue hover:bg-off-white hover:text-core-blue focus-visible:bg-off-white focus-visible:text-core-blue",
    ),
    primary: cn(
      "bg-royal-blue text-white hover:bg-core-blue focus-visible:bg-core-blue",
    ),
    secondary: cn(
      `bg-orange text-white hover:bg-dark-orange focus-visible:bg-dark-orange ${FOCUS_OUTLINE_STYLES_SECONDARY}`,
    ),
    standard: cn(
      "border border-dark-gray bg-white text-royal-blue hover:bg-off-white hover:text-core-blue focus-visible:bg-off-white focus-visible:text-core-blue",
    ),
  },
  disabled: {
    darkMinimal: DISABLED_BUTTON_STYLES_MINIMAL,
    minimal: DISABLED_BUTTON_STYLES_MINIMAL,
    primary: DISABLED_BUTTON_STYLES,
    secondary: DISABLED_BUTTON_STYLES,
    standard: DISABLED_BUTTON_STYLES,
  },
  fullWidth: cn("min-w-full"),
  linkColor: {
    darkMinimal: cn(
      `min-w-0 bg-core-blue px-2 text-white hover:text-light-gray focus-visible:text-light-gray ${FOCUS_OUTLINE_STYLES_BUTTON_LINK}`,
    ),
    minimal: cn(
      `min-w-0 bg-white px-2 text-royal-blue hover:bg-off-white focus-visible:bg-off-white ${FOCUS_OUTLINE_STYLES_BUTTON_LINK}`,
    ),
    primary: cn(
      `bg-royal-blue text-white hover:bg-core-blue focus-visible:bg-core-blue ${FOCUS_OUTLINE_STYLES_BUTTON_LINK}`,
    ),
    secondary: cn(
      `bg-orange text-white hover:bg-dark-orange focus-visible:bg-dark-orange ${FOCUS_OUTLINE_STYLES_BUTTON_LINK} ${FOCUS_OUTLINE_STYLES_SECONDARY_LINK}`,
    ),
    standard: cn(
      `border border-dark-gray bg-white text-royal-blue hover:bg-off-white focus-visible:bg-off-white ${FOCUS_OUTLINE_STYLES_BUTTON_LINK}`,
    ),
  },
  loading: cn("pointer-events-none opacity-60"),
  size: {
    large: cn("min-w-[196px] py-4 leading-6"),
    medium: cn("min-w-36 py-3.5 text-[14px]/5"),
    small: cn("min-w-32 py-2.5 text-[14px]/5"),
  },
} satisfies ButtonStyles;
